module.exports = __webpack_public_path__ + "img/logo-theater-des-lachens.5dc0962f.svg";